<div class="modal fade info-modal" [id]="modalId()" msEscClose (escPressed)="onConfirmClicked()"
    data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1"
    aria-labelledby="" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
            <div class="modal-header border-0 p-4">
                <h5 class="modal-title">{{ title() }}</h5>
            </div>
            <div class="modal-body text-center">
                @switch (modalType()) {
                    @case (ModalTypes.Success) {
                        <fa-duotone-icon icon="circle-check" class="info-icon text-success" />
                    }

                    @case (ModalTypes.Failure) {
                        <fa-duotone-icon icon="circle-xmark" class="info-icon text-danger" />
                    }

                    @case (ModalTypes.Information) {
                        <fa-duotone-icon icon="circle-info" class="info-icon text-primary" />
                    }

                    @case (ModalTypes.Question) {
                        <fa-duotone-icon icon="circle-question" class="info-icon text-info" />
                    }

                    @case (ModalTypes.Exclamation) {
                        <fa-duotone-icon icon="circle-exclamation" class="info-icon text-warning" />
                    }
                }

                <h6 class="pt-4 text-break">{{ message() }}</h6>
            </div>
            <div class="modal-footer border-0 d-flex justify-content-center p-4">
                <button type="button" class="btn btn-primary w-25" (click)="onConfirmClicked()">
                    {{ acknowledgeButtonText() }}
                </button>
            </div>
        </div>
    </div>
</div>